import { render, staticRenderFns } from "./ItemOption.vue?vue&type=template&id=bb061bbc&"
import script from "./ItemOption.vue?vue&type=script&lang=js&"
export * from "./ItemOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports